import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal';
import ConfirmDialog from '../common/ConfirmDialog';
import './ModalForms.css';
import '../common/IconButton.css';
import { IconTrash } from '../common/Icons';
import { digitsOnly, formatCuil } from '../../utils/formatters';

const emptyOperator = { name: '', cuit: '' };

const OperatorModal = ({ isOpen, onClose, onSave, onDelete, initialData }) => {
  const [formData, setFormData] = useState(emptyOperator);
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: String(initialData.name || '').toUpperCase(),
        cuit: formatCuil(initialData.cuit || initialData.cuil || ''),
      });
    } else {
      setFormData(emptyOperator);
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextValue =
      name === 'name'
        ? String(value).toUpperCase()
        : name === 'cuit'
          ? formatCuil(value)
          : value;
    setFormData((prev) => ({ ...prev, [name]: nextValue }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave({
      ...formData,
      name: String(formData.name || '').toUpperCase(),
      cuit: digitsOnly(formData.cuit),
    });
  };

  return (
    <Modal
      title={initialData ? 'Editar Operador' : 'Nuevo Operador'}
      isOpen={isOpen}
      onClose={onClose}
      onEnter={() => handleSubmit()}
      footer={(
        <div className="modal-footer">
          <div className="footer-left">
            {initialData && (
              <button
                type="button"
                className="icon-btn icon-btn--delete"
                onClick={() => setConfirmOpen(true)}
                aria-label="Eliminar operador"
                title="Eliminar"
              >
                <IconTrash />
              </button>
            )}
          </div>
          <div className="footer-actions">
            <button type="button" className="btn secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" form="operator-modal-form" className="btn">Guardar</button>
          </div>
        </div>
      )}
    >
      <form id="operator-modal-form" className="modal-form" onSubmit={handleSubmit}>
        <div className="form-grid two-columns">
          <label>
            Nombre
            <input name="name" value={formData.name} onChange={handleChange} required />
          </label>
          <label>
            CUIT
            <input name="cuit" value={formData.cuit} onChange={handleChange} required />
          </label>
        </div>
      </form>

      <ConfirmDialog
        isOpen={confirmOpen}
        title="Eliminar operador"
        message="¿Está seguro que desea eliminar este operador?"
        confirmLabel="Eliminar"
        cancelLabel="Cancelar"
        onConfirm={() => {
          setConfirmOpen(false);
          onDelete?.(initialData?.id);
        }}
        onCancel={() => setConfirmOpen(false)}
      />
    </Modal>
  );
};

export default OperatorModal;
